import { AppScrollbar } from "_lib";
import styled from "styled-components";

export const StyledAuthWrapperScrollbar = styled(AppScrollbar)`
  height: 100svh;
  padding: 0px;
  overflow-x: hidden;
  background: ${({ theme }) => theme.palette.background.authOuter};

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.lg}px) {
    height: 100%;
    width: 100%;
    top: 0;
  }
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding: 0px;
    overflow-x: hidden;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.xxs}px) {
    padding: 0px;
  }
`;

export const StyledAuthWrapper = styled.div`
  background: ${({ theme }) => theme.palette.background.authOuter};
  height: 100%;
  display: flex;
  align-items: stretch;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.lg}px) {
    padding: 0;
  }
`;

export const StyledAppWrapperContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: stretch;
  gap: 12px;
`;

export const StyledAuthWrapperFormPanel = styled.div`
  flex: 1;
  min-height: 0;
  box-sizing: border-box;
  background: ${({ theme }) => theme.palette.background.auth};
  border: 3px solid ${({ theme }) => theme.palette.background.authOuter};
  border-radius: 32px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.lg}px) {
    border-radius: 0;
    border: none;
    height: 100svh;
  }
`;

export const StyledAuthWrapperCarouselPanel = styled.div`
  flex: 1;
  min-height: 0;
  box-sizing: border-box;
  background: ${({ theme }) => theme.palette.background.auth === "#16283A" ? "#16283A" : "#111C28"};
  border: 3px solid ${({ theme }) => theme.palette.background.authOuter};
  border-radius: 32px;
  overflow: hidden;
  position: relative;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.lg}px) {
    display: none;
  }
`;
